<template>
  <div class="rate-count">
    <div class="star"></div>
    <div class="rate">{{ num }}/100</div>
    <img class="tip" src="@/assets/zs_imgs/ck-xwh.png" />
  </div>
</template>
<script>
export default {
  name: "RateCount",
  props: {
    num: {
      type: Number,
      default: 0
    }
  }
};
</script>
<style lang="less" scoped>
.rate-count {
  border-radius: 100px;
  padding: 2px;
  padding-right: 6px;
  display: flex;
  align-items: center;
  gap: 12px;
  background-color: #dedad2;
  width: fit-content;
  cursor: default;
  .star {
    border-radius: 50%;
    width: 23px;
    height: 23px;
    background-color: rgb(66, 66, 66);
    background-image: url("~@/assets/zs_imgs/ck-star5.png");
    background-size: 16px 16px;
    background-position: center;
    background-repeat: no-repeat;
  }
  .rate {
    color: rgb(64, 64, 64);
    font-size: 14px;
  }
  .tip {
    width: 14px;
    height: 14px;
    background-color: #7a7974;
    object-fit: contain;
    object-position: center;
    border-radius: 50%;
    padding: 2px;
  }
}
</style>
